<div class="d-flex justify-content-center" *ngIf="isLoading">
  <dcp-loading-indicator/>
</div>
<div [class.d-none]="!displayComponent">
  <div [attr.data-cy]="'delegoRapidpayIFrameHost'"
       id="delegoRapidpayIFrameHost">
  </div>
  <ng-container *ngIf="isNeedToShowCloseButton() | async">
    <udex-button
      size="Large"
      design="Secondary"
      data-cy="delegoRapidpay-close-button"
      (click)="closeDelegoRapidPayIFrame()">
      {{'checkout.digitalNativeCheckout.paymentType.cc.cancelButton' | cxTranslate}}
    </udex-button>
  </ng-container>
</div>

